<div class="appointments-container"
     (swipeleft)="swipeDayForward()"
     (swiperight)="swipeDayBackward()">
  <div class="appointments" *ngIf="(loading$ | async) == false">
    <app-list-item *ngFor="let timeslot of timeslots$ | async" [timeslot]="timeslot"></app-list-item>
    <app-no-data *ngIf="(timeslots$ | async).length <= 0"></app-no-data>
  </div>
</div>
